<script setup lang="ts">
import KpSelectField from '@/components/KpSelectField.vue';
import { computed, ref, type Ref } from 'vue';
import Button from 'primevue/button';
import KpCheckboxField from '@/components/KpCheckboxField.vue';

const emit = defineEmits(['next', 'prev']);

const props = defineProps<{
    typ: string | null;
    kanton_id: number | null;
    jahr: number | null;
}>();

const data: Ref<ProduktionAuswertungsDaten> = ref({
    aggregation: null,
    solarstromanlagen_beruecksichtigen: true,
});

enum Aggregation {
    gemeinde = 'gemeinde',
    nutzungsart = 'nutzungsart',
    bauperiode = 'bauperiode',
}

export type ProduktionAuswertungsDaten = {
    aggregation: Aggregation | null;
    solarstromanlagen_beruecksichtigen: boolean;
};

function prev() {
    cleanEntries();
    emit('prev');
}

function next() {
    emit('next', data.value);
    cleanEntries();
}

function cleanEntries() {
    data.value.aggregation = null;
    data.value.solarstromanlagen_beruecksichtigen = true;
}
const nextEnabled = computed(() => {
    if (props.typ === 'anzahl_photovoltaikanlagen' || props.typ === 'installierte_leistung_photovoltaikanlagen') {
        return data.value.aggregation !== null;
    } else {
        return true;
    }
});
</script>

<template>
    <div class="formgrid grid align-items-start">
        <template v-if="typ === 'anzahl_photovoltaikanlagen' || typ === 'installierte_leistung_photovoltaikanlagen'">
            <KpSelectField
                class="col-6"
                fluid
                :label="$t('aggregation')"
                v-model="data.aggregation"
                :options="Object.entries(Aggregation).map(([id, value]) => ({ id, value: $t(value) }))"
                option-label="value"
                option-value="id"
            ></KpSelectField>
        </template>
        <template v-else></template>
    </div>
    <div class="formgrid grid align-items-start">
        <KpCheckboxField
            class="col-12"
            :label="$t('solarstromanlagen_beruecksichtigen')"
            binary
            v-model="data.solarstromanlagen_beruecksichtigen"
        />
    </div>
    <div class="flex pt-6 justify-content-between">
        <Button :label="$t('zurueck')" severity="secondary" icon="fa-solid fa-arrow-left" @click="prev()"></Button>
        <Button
            :label="$t('weiter')"
            :disabled="!nextEnabled"
            icon="fa-solid fa-arrow-right"
            iconPos="right"
            @click="() => next()"
        ></Button>
    </div>
</template>
